<template>
    <div class="h-100">
        <navigation-bar :project-id="projectId"></navigation-bar>
        <main id="main">
            <document-finder v-show="$route.name==='document_finder'" :project-id="projectId"></document-finder>
            <documents v-show="$route.name==='documents'" :project-id="projectId"
                       ref="documents"></documents>
        </main>
    </div>
</template>

<script>
    import NavigationBar from "@/components/NavigationBar";
    import DocumentFinder from "@/views/DocumentFinder";
    import Documents from "@/views/Documents";
    export default {
        name: "OpenProject",
        components: {Documents, DocumentFinder, NavigationBar},
        methods: {
            closeAllTabs() {
                return this.$refs.documents.closeAllTabs();
            },
            closeAllTabsSwiftly() {
                this.$refs.documents.closeAllTabsSwiftly();
            }
        },
        props: {
            projectId: String,
        },
    }
</script>

<style scoped>

</style>
